import styles from './SheetOverlay.module.scss';

export type SheetOverlayProps = {
  testId: string;
  label: string;
  isDismissible?: boolean;
  onDismiss: () => void;
  children: React.ReactNode;
};

/**
 * A page-level bottom sheet over a dimmed page (the superlike sheet's
 * pattern, review B4): it lives outside the tab bar's single slot, so the
 * deck's buttons can never overwrite it and the soft keyboard lifts it as a
 * whole.
 */
export const SheetOverlay = ({
  testId,
  label,
  isDismissible = true,
  onDismiss,
  children,
}: SheetOverlayProps) => {
  return (
    <div className={styles.overlay} data-test-id={testId}>
      <button
        type="button"
        aria-label="Закрыть"
        className={styles.dim}
        data-test-id={`${testId}-dim-button`}
        onClick={isDismissible ? onDismiss : undefined}
      />
      <section role="dialog" aria-label={label} className={styles.sheet}>
        {children}
      </section>
    </div>
  );
};
